module.exports = __webpack_public_path__ + "assets/devices/TOWER-CAM-PG2-79603fc9d71e6a3023bc26e654998757.svg";